module.exports = "h1 {\n  color: #616161;\n}\n"